import { render } from "./ProfileSettings.vue?vue&type=template&id=75248712&scoped=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"

import "./ProfileSettings.vue?vue&type=style&index=0&id=75248712&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75248712"]])

export default __exports__